import { EventsOfTask } from 'pages/Tasks/types'
import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import type { GetAcceptButtonProps } from '../../types'

export const getAcceptButton = ({
  sendEvent,
  refetch,
  t,
  buttonProps = {},
  onSuccess,
}: GetAcceptButtonProps): Action => ({
  label: t('workTimeControl.buttons.accept'),
  onClick: () => {
    sendEvent(EventsOfTask.monthlySheetAccept, undefined, () => {
      refetch()
      onSuccess?.()
    })
  },
  variant: 'contained',
  color: 'primary',
  testId: 'task-detail_accept-sheet',
  ...buttonProps,
})
